module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_5012.150e14b6.png";